import { MARKER_ALTITUDE_COORDS } from 'entities/map';

import { getRoadsideServiceType } from './getRoadsideServiceType';

export const getRoadsideServiceAltitudeCoordinate = (roadsideServiceCode: number) => (

  MARKER_ALTITUDE_COORDS[getRoadsideServiceType(roadsideServiceCode)] || 0
);

export const getSortedRoadsideServices = (roadsideServiceCodes: number[]) => roadsideServiceCodes.reduce((acc, roadsideServiceCode) => {
    acc[getRoadsideServiceAltitudeCoordinate(roadsideServiceCode)] = roadsideServiceCode;
    return acc;
  }, [] as number[])
  .filter(item => item !== undefined)
  .reverse();
